<template>
  <FaIcon :icon="['fas', 'rex']" />
</template>
